import {
  useRecordContext,
  useTranslate,
  useRefresh,
} from 'react-admin';
import { useMemo, useState } from 'react';
import { Tooltip } from '@mui/material';
import {
  AddCertifiedUsersModal,
  type CertifiedUsersCategory,
} from './AddCertifiedUsersModal';
import { buildExistingCertifiedUsers } from '../../../utils/certifiedUsersAssignments';
import type { CertifiedAssetRow, AssigneeChoice } from '../../../utils/certifiedUsersAssignments';
import { BhvkTableActionButton } from '../buttons/ActionButtons';

export const AddCertifiedUsersRowButton = (props: {
  disabled?: boolean;
  baseChoices: AssigneeChoice[];
  assetsByCategoryId: Record<string, CertifiedAssetRow[]>;
  certifiedAssetIdsByCategoryId: Record<string, Set<string>>;
  isChoicesLoading?: boolean;
}) => {

  const record = useRecordContext();
  const translate = useTranslate();
  const refresh = useRefresh();
  const [open, setOpen] = useState(false);

  const categoryId = String(record?.id ?? '');

  const existingUsers = useMemo(
    () => buildExistingCertifiedUsers(
      props.assetsByCategoryId[categoryId] ?? [],
      categoryId,
    ),
    [props.assetsByCategoryId, categoryId],
  );

  if (!record) return null;

  const category: CertifiedUsersCategory = {
    id: String(record.id),
    name: record.name,
    validityPeriod: record.validityPeriod,
    isDocumentaryProofRequired: record.isDocumentaryProofRequired ?? false,
  };

  const isDisabled = props.disabled
    || props.isChoicesLoading
    || (props.baseChoices.length === 0 && existingUsers.length === 0);

  const button = (
    <BhvkTableActionButton
      label={translate('resources.certification-categories.text.manage_certificates', { category: category.name })}
      onClick={() => setOpen(true)}
      disabled={isDisabled}
    />
  );

  return (
    <>
      {isDisabled && !props.disabled && !props.isChoicesLoading ? (
        <Tooltip title={translate('resources.certification-categories.text.all_users_already_certified')}>
          <span>{button}</span>
        </Tooltip>
      ) : (
        button
      )}
      <AddCertifiedUsersModal
        open={open}
        onClose={() => setOpen(false)}
        onComplete={() => {

          setOpen(false);
          refresh();

        }}
        categories={[category]}
        choices={props.baseChoices}
        existingUsers={existingUsers}
        isChoicesLoading={props.isChoicesLoading}
      />
    </>
  );

};
